import React, { useCallback, useEffect, useMemo, useState } from "react";
import "./LeftSidebar.scss";
import { IoChevronDown, IoChevronUp, IoSearchOutline } from "react-icons/io5";
import { Category, Filter, Song } from "../../../@core/models";
import RestClient from "../../../@core/restClient";
import { Link, useNavigate, useParams } from "react-router-dom";
import debounce from "lodash/debounce";

type CategoriesState = [
  categories: Category[],
  setCategories: (categories: Category[]) => void
];

type SongsState = [songs: Song[], setSongs: (songs: Song[]) => void];

type FilterState = [
  filter: Filter,
  setFilter: (arg: Filter | ((current: Filter) => Filter)) => void
];

const LeftSidebar = ({
  songListModified,
  closeSidebar,
  useCategories,
  onSongsNumber,
  newSongId,
  categoryList,
  songDeleted
}: any) => {
  const { songbookId, songId } = useParams();
  //const [categories, setCategories]: CategoriesState = useState<Category[]>([]);
  const [songs, setSongs]: SongsState = useState<Song[]>([]);
  const [filter, setFilter]: FilterState = useState<Filter>({
    category: "",
    query: ""
  });
  const [filteredSongs, setFilteredSongs] = useState<Song[]>([]);
  const [sort, setSort] = useState("");
  const [sortOption, setSortOption] = useState("Сортувати");
  const [sortIsOpen, setSortIsOpen] = useState(false);
  const [category, setCategory] = useState("Всі категорії");
  const [categoriesOpen, setCategoriesOpen] = useState(false);
  const [showSubtitle, setShowSubtitle] = useState(true);
  const [options, setOptions] = useState("hideOptions");
  const navigate = useNavigate();

  const deferredSetQueryHandler = useCallback(
    debounce((event: React.ChangeEvent<HTMLInputElement>) => {
      setFilter((current: Filter) => ({
        ...current,
        query: event.target.value
      }));
    }, 200),
    []
  );

  const getSongList = async () => {
    if (!songbookId) {
      return;
    }
    try {
      const response = await RestClient.getSongList(
        songbookId
        // filter.category,
        //  filter.query
      );
      setSongs(response.sort((a, b) => Number(b.id) - Number(a.id)) || []);
      // setSongs(response.sort((a, b) => a.title.localeCompare(b.title)));
      setFilteredSongs(
        response.sort((a, b) => Number(b.id) - Number(a.id)) || []
      );
      // setFilteredSongs(
      //   response.sort((a: any, b: any) => a.title - b.title) || []
      // );

      onSongsNumber(response.length);
      if (response.length !== 0) {
        if (songListModified && !songDeleted) {
          navigate(`/songbook/${songbookId}/song/${newSongId}`);
        } else if (response.some((song) => song.id === Number(songId))) {
          navigate(`/songbook/${songbookId}/song/${songId}`);
        } else {
          navigate(`/songbook/${songbookId}/song/${response[0].id}`);
        }
      } else {
        navigate(`/songbook/${songbookId}`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // FILTER SONGS BY SEARCH AND CATEGORY

  const normalize = (str: any) => {
    if (!str) return "";
    return str
      .toLowerCase()
      .replace(/[.,\-/#!$%^&*;:{}=_`~()?'"@]/g, "") // Remove symbols
      .replace(/\s+/g, " ") // Normalize spaces
      .trim();
  };
  const filterSongList = () => {
    const normalizedQuery = normalize(filter.query);

    const filtered = songs.filter((el) => {
      const titleMatch = normalize(el.title).includes(normalizedQuery);
      const subTitleMatch = normalize(el.subTitle).includes(normalizedQuery);
      const categoryMatch = el.categories
        ?.map((item) => item.id)
        .includes(filter.category);

      return filter.category && !filter.query
        ? categoryMatch
        : filter.query && !filter.category
          ? titleMatch || subTitleMatch
          : filter.category && filter.query
            ? (categoryMatch && titleMatch) || (categoryMatch && subTitleMatch)
            : true;
    });

    setFilteredSongs(filtered);
  };

  //CATEGORIES BOX
  const openCategories = (e: any) => {
    e.stopPropagation();
    setCategoriesOpen(!categoriesOpen);
    if (sortIsOpen) {
      setSortIsOpen(false);
    }
  };

  const chooseCategory = (id: any, name: any, e: any) => {
    e.stopPropagation();
    setCategoriesOpen(false);
    setCategory(name);
    setFilter({ ...filter, category: id });
  };

  //SORTING SONG LIST
  const openSort = (e: any) => {
    e.stopPropagation();
    setSortIsOpen(!sortIsOpen);
    if (categoriesOpen) {
      setCategoriesOpen(false);
    }
  };

  useEffect(() => {
    if (sortIsOpen) {
      document.body.addEventListener("click", () => {
        setSortIsOpen(false);
        setCategoriesOpen(false);
      });
    } else {
      return;
    }
  }, [sortIsOpen, categoriesOpen]);

  const sorting = (option: any, e: any) => {
    e.stopPropagation();
    setSortIsOpen(false);
    if (option === "az") {
      setSort(option);
      setSortOption("А - Я");
    }

    if (option === "za") {
      setSort(option);
      setSortOption("Я - А");
    }
    if (option === "newOld") {
      setSort(option);
      setSortOption("Нові - Старі");
    }
    if (option === "") {
      setSort(option);
      setSortOption("Не сортувати");
    }
    if (option === "oldNew") {
      setSort(option);
      setSortOption("Старі - Нові");
    }
  };
  useEffect(() => {
    if (sort === "az") {
      const sorted = [...filteredSongs].sort((a, b) =>
        a.title.localeCompare(b.title)
      );
      setFilteredSongs(sorted);
    }

    if (sort === "za") {
      const sorted = [...filteredSongs].sort((a, b) =>
        b.title.localeCompare(a.title)
      );
      setFilteredSongs(sorted);
    }
    if (sort === "oldNew") {
      const sorted = [...filteredSongs].sort(
        (a, b) => Number(a.id) - Number(b.id)
      );
      setFilteredSongs(sorted);
    }
    if (sort === "newOld" || sort === "") {
      const sorted = [...filteredSongs].sort(
        (a, b) => Number(b.id) - Number(a.id)
      );
      setFilteredSongs(sorted);
    }
  }, [sort]);

  useEffect(() => {
    (async () => {
      await getSongList();
    })();
  }, [songbookId]);

  useEffect(() => {
    (async () => {
      if (!songListModified) {
        return;
      } else {
        await getSongList();
      }
    })();
  }, [songListModified]);

  useEffect(() => {
    filterSongList();
  }, [filter]);

  // STOP PROPAGATION ON INPUT TO FIND A SONG
  const notHide = (e: any) => {
    e.stopPropagation();
  };

  // ClOSE SORT OR CATIGORY BOXES

  const toggleCategories = () => {
    setCategoriesOpen(!categoriesOpen);
    if (sortIsOpen) {
      setSortIsOpen(false);
    } else {
      return;
    }
  };
  const toggleSort = () => {
    setSortIsOpen(!sortIsOpen);
    if (categoriesOpen) {
      setCategoriesOpen(false);
    }
  };

  // HANDLE SHOW SUBTITLE BUTTON

  useEffect(() => {
    const subtitle = JSON.parse(localStorage.getItem("subtitle") || "true");
    setShowSubtitle(subtitle);
  }, []);

  const switchShowSubtitle = () => {
    if (showSubtitle) {
      setShowSubtitle(false);
      localStorage.setItem("subtitle", JSON.stringify(false));
    } else {
      setShowSubtitle(true);
      localStorage.setItem("subtitle", JSON.stringify(true));
    }
  };

  // SHOW OPTIONS

  const toggleOptions = () => {
    if (options === "showOptions") {
      setOptions("hideOptions");
    } else {
      setOptions("showOptions");
    }
  };

  return (
    <div className="left-sidebar" onClick={(e) => notHide(e)}>
      <div className="search-field">
        <input
          type="text"
          className="search-song"
          placeholder="Знайти у збірнику ..."
          onChange={deferredSetQueryHandler}
          onClick={(e) => notHide(e)}
        />
        <IoSearchOutline className="search-icon" />
      </div>
      <div className="optionFilterBtn" onClick={toggleOptions}>
        <div>Фільтри</div>
        {options === "showOptions" ? (
          <IoChevronUp className="icon" />
        ) : (
          <IoChevronDown className="icon" />
        )}
      </div>
      <div className={options}>
        {useCategories ? (
          <div className="topic">
            <div className="topic-input-box">
              <input
                readOnly
                type="text"
                className="topic-field"
                value={category}
                onClick={(e) => openCategories(e)}
              />
              {categoriesOpen ? (
                <IoChevronUp
                  className="chevron-icon"
                  onClick={toggleCategories}
                />
              ) : (
                <IoChevronDown
                  className="chevron-icon"
                  onClick={toggleCategories}
                />
              )}
            </div>
            {categoriesOpen ? (
              <div className="topic-options">
                <p
                  className="topic-options-item"
                  onClick={(e) => chooseCategory(null, "Всі категорії", e)}
                >
                  Всі категорії
                </p>
                {categoryList?.map((category: Category) => (
                  <p
                    key={category.id}
                    className="topic-options-item"
                    onClick={(e) =>
                      chooseCategory(category.id, category.name, e)
                    }
                  >
                    {category.name}
                  </p>
                ))}
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
        <div className="topic">
          <div className="topic-input-box">
            <input
              readOnly
              type="text"
              className="topic-field"
              value={sortOption}
              onClick={(e) => openSort(e)}
            />
            {sortIsOpen ? (
              <IoChevronUp className="chevron-icon" onClick={toggleSort} />
            ) : (
              <IoChevronDown className="chevron-icon" onClick={toggleSort} />
            )}
          </div>
          {sortIsOpen ? (
            <div className="topic-options">
              <p className="topic-options-item" onClick={(e) => sorting("", e)}>
                Не сортувати
              </p>
              <p
                className="topic-options-item"
                onClick={(e) => sorting("az", e)}
              >
                А - Я
              </p>
              <p
                className="topic-options-item"
                onClick={(e) => sorting("za", e)}
              >
                Я - А
              </p>
              <p
                className="topic-options-item"
                onClick={(e) => sorting("newOld", e)}
              >
                Останні - перші
              </p>
              <p
                className="topic-options-item"
                onClick={(e) => sorting("oldNew", e)}
              >
                Перші - останні
              </p>
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="switchSubtitle-box">
          <p>Підзаголовки </p>

          <div
            className={`switchSubtitle ${showSubtitle ? "onSubtitle" : ""}`}
            onClick={switchShowSubtitle}
          >
            <div className="sliderSubtitle"></div>
          </div>
          <p> {showSubtitle ? "On" : "Off"}</p>
        </div>
      </div>
      <ul className="contents">
        {filteredSongs?.map((song: Song) => (
          <li
            key={song.id}
            className={Number(songId) === song.id ? "is-active" : ""}
          >
            <Link
              to={`/songbook/${songbookId}/song/${song.id}`}
              onClick={closeSidebar}
            >
              {song.title}
              {showSubtitle ? (
                <span className="songSubtitle">{song.subTitle}</span>
              ) : null}
            </Link>
          </li>
        ))}
      </ul>
      <p className="songsnumber">Всього пісень - {songs.length}</p>
    </div>
  );
};

export default LeftSidebar;
